import { POST, GET } from '../../utils/api';
import {
	USER_ADFS_LOGIN_URL,
	USER_LOGIN_URL,
	USER_FORGOT_PASSWORD_URL,
	USER_SMS_PINCODE_VERIFICATION_URL,
	USER_NEW_PASSWORD_URL,
	USER_SET_PASSWORD_URL,
	USER_PERSONAL_DATA_VERIFICATION,
	USER_TWO_FACTOR_AUTH,
	USER_RESET_TWO_FACTOR_AUTH,
	USER_AZURE_AD_LOGIN_URL,
} from './consts';

export const getInitialLoginData = (params) => GET(USER_LOGIN_URL, params);

export const login = (data) => POST(USER_LOGIN_URL, data);
export const loginAdfs = (params) => GET(USER_ADFS_LOGIN_URL, params);
export const loginAzureAd = (params) => GET(USER_AZURE_AD_LOGIN_URL, params);

export const forgotPassword = (data) => POST(USER_FORGOT_PASSWORD_URL, data);

export const getInitialCheckSmsPincodeData = (params) => GET(USER_SMS_PINCODE_VERIFICATION_URL, params);

export const postInitialCheckSmsPincodeData = (data) => POST(USER_SMS_PINCODE_VERIFICATION_URL, data);

export const fetchInitialNewPasswordData = (params) => GET(USER_NEW_PASSWORD_URL, params);
export const postNewPassword = (data) => POST(USER_NEW_PASSWORD_URL, data);

export const fetchInitialSetPasswordData = (params) => GET(USER_SET_PASSWORD_URL, params);
export const postSetPassword = (data) => POST(USER_SET_PASSWORD_URL, data);

export const fetchInitialPersonalDataVerification = (params) => GET(USER_PERSONAL_DATA_VERIFICATION, params);
export const postPersonalDataVerification = (data) => POST(USER_PERSONAL_DATA_VERIFICATION, data);

export const fetchTwoFactorAuth = (params) => GET(USER_TWO_FACTOR_AUTH, params);
export const postTwoFactorVerifiedAuth = (data) => POST(USER_TWO_FACTOR_AUTH, data);

export const postResetTwoFactorAuth = () => POST(USER_RESET_TWO_FACTOR_AUTH);
